function closeDrawerMenu() {
  document.querySelector(".menu-open").classList.remove("menu-open");
  document.querySelector(".menu-drawer-container").removeAttribute("open");
  document.querySelector("body").classList.remove("overflow-hidden-desktop");
  if (typeof gtag !== "undefined") {
    console.log("Closed header drawer");

    gtag("event", "user_interaction", {
      link_text: "",
      link_target: "",
      event_category: "User Click",
      event_type: "Close Header Drawer",
    });
  }
}

window.addEventListener("DOMContentLoaded", async () => {
  /* START OF PROMO ADD TO CART */

  /* Get URL Search params */
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  /* Check if our get is there */
  const promoVIP = urlParams.get("promo");

  if (promoVIP === "VIP2024") {
    /* Check cart contents for a metal shaker */
    const cartContents = await fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        return data;
      });

    let foundShaker = false;

    if (cartContents.items.length > 0) {
      cartContents.items.forEach((item) => {
        if (item.id === 40501535506513) {
          foundShaker = true;
          return;
        }
      });
    }

    if (!foundShaker) {
      let formData = {
        items: [
          {
            id: 40501535506513,
            quantity: 1,
          },
        ],
      };

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          return data;
        });
    }
  }

  /* END OF PROMO ADD TO CART */

  document.querySelectorAll(".js-op-anchor-link").forEach((el) => {
    let menuForClose = document.querySelector(".menu-drawer-container summary");
    el.addEventListener("click", () => {
      menuForClose.click();
    });
  });

  document.querySelector(".menu-backdrop")?.addEventListener("click", () => {
    closeDrawerMenu();
  });

  /* Blog filtering */
  document.querySelector("#js-open-filter-posts")?.addEventListener("click", () => {
    const desktopMode = window.matchMedia("(min-width: 1200px)").matches;
    const filterDrawerMenu = document.querySelector("#mobile-filter-drawer-menu");

    if (!desktopMode) {
      const currentScroll = window.scrollY;
      const getAnnouncementBarHeight = document.querySelector(".utility-bar")?.offsetHeight;
      const headerHeight = document.querySelector("sticky-header")?.offsetHeight;

      if (getAnnouncementBarHeight && window.scrollY < 44) {
        const currOffset = getAnnouncementBarHeight - window.scrollY + headerHeight;
        filterDrawerMenu.style = `top: ${currOffset}px;`;
      } else {
        filterDrawerMenu.style = `top: ${headerHeight}px;`;
      }
    }

    filterDrawerMenu.classList.remove("twcss-translate-x-full");
    document.querySelector("#mobile-filter-backdrop").classList.remove("twcss-hidden");
    document.querySelector("body").classList.add("lock-background");
    document.querySelector("html").classList.add("lock-background");
    document.ontouchmove = function (e) {
      e.preventDefault();
    };
  });
  document.querySelector("#js-close-filter-posts")?.addEventListener("click", () => {
    document.querySelector("#mobile-filter-drawer-menu").classList.add("twcss-translate-x-full");
    document.querySelector("body").classList.remove("lock-background");
    document.querySelector("html").classList.remove("lock-background");

    document.querySelector("#mobile-filter-backdrop").classList.add("twcss-hidden");
    document.ontouchmove = function (e) {
      return true;
    };
  });
  document.querySelector("#mobile-filter-backdrop")?.addEventListener("click", (e) => {
    e.target.classList.add("twcss-hidden");
    document.querySelector("#mobile-filter-drawer-menu").classList.add("twcss-translate-x-full");
    document.querySelector("body").classList.remove("lock-background");
    document.querySelector("html").classList.remove("lock-background");
    document.ontouchmove = function (e) {
      return true;
    };
  });
  document.querySelector("#filter-close-button")?.addEventListener("click", (e) => {
    document.querySelector("#mobile-filter-backdrop").classList.add("twcss-hidden");
    document.querySelector("#mobile-filter-drawer-menu").classList.add("twcss-translate-x-full");
    document.querySelector("body").classList.remove("lock-background");
    document.querySelector("html").classList.remove("lock-background");
    document.ontouchmove = function (e) {
      return true;
    };
  });
  document.querySelector(".blog-tag__mobile-search-button")?.addEventListener("click", (e) => {
    document.querySelector("#mobile-filter-backdrop").classList.add("twcss-hidden");
    document.querySelector("#mobile-filter-drawer-menu").classList.add("twcss-translate-x-full");
    document.querySelector("body").classList.remove("lock-background");
    document.querySelector("html").classList.remove("lock-background");
    document.ontouchmove = function (e) {
      return true;
    };
  });

  document.querySelector("#js-gift-open")?.addEventListener("click", (e) => {
    console.log("open");
    document.querySelector("gift-drawer").open();
  });

  /* Add upsell data to cart attributes for reporting on upsells & attributing to location */
  const params = new URL(document.location.toString()).searchParams;
  const fromParam = params.get("from");

  const productForm = document.querySelector("#MainContent .product-form form");
  const productPage = document.querySelector("body.page-product");
  const productSku = document.querySelector("#MainContent .product-form")?.dataset.sku;

  if (fromParam && productForm && productSku && productPage) {
    console.log("detected came from upsell drawer");
    productForm.insertAdjacentHTML(
      "beforeend",
      ` <input
          type="hidden"
          name="attributes[upsell-${productSku}]"
          value="product page from drawer"
        >`,
    );
  }
});

function customDebounce(callback, delay) {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(callback, delay);
  };
}
function bundleVariantLoading() {
  const bundleButton = document.querySelector(".product__info-container .bundle-button");
  bundleButton?.classList.remove("twcss-bg-dukeorange");
  bundleButton?.classList.add("twcss-bg-dukeorange-light");
  bundleButton?.querySelectorAll(".hidden").forEach((el) => {
    el.classList.remove("hidden");
  });
  if (bundleButton?.querySelector(".bundle-button__text")) {
    bundleButton.querySelector(".bundle-button__text").innerText = "";
  }
}

window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".menu-drawer__navigation [href*='#']").forEach((locationLink) => {
    /* If we are on the same page as the location link, close menu */
    const relativeLink = locationLink.getAttribute("href").split("#");
    console.log(relativeLink[0], window.location.pathname);

    if (relativeLink[0] === window.location.pathname) {
      locationLink.addEventListener("click", () => {
        closeDrawerMenu();
      });
    }
  });

  /* GA Tracking */
  document.querySelectorAll(".upsell-add-btn").forEach((item) => {
    item.addEventListener("click", (event) => {
      if (typeof gtag !== "undefined") {
        gtag("event", "user_interaction", {
          link_text: event.target
            .closest(".drawer__upsell-item-text")
            .querySelector(".drawer__upsell-item-title")
            .innerText.trim(),
          link_target: "",
          event_category: "User Click",
          event_type: "Drawer Upsell",
        });
      }
    });
  });

  document.querySelectorAll(".tab-switcher--inactive").forEach((item) => {
    item.addEventListener("click", () => {
      if (typeof gtag !== "undefined") {
        gtag("event", "user_interaction", {
          link_text: item?.innerText.trim(),
          link_target: item?.getAttribute("href"),
          event_category: "User Click",
          event_type: "Tab Switcher",
        });
      }
    });
  });

  document.querySelectorAll(".announcement-bar__link").forEach((item) => {
    item.addEventListener("click", (e) => {
      if (typeof gtag !== "undefined") {
        gtag("event", "user_interaction", {
          link_text: item?.innerText.trim(),
          link_target: item?.getAttribute("href"),
          event_category: "User Click",
          event_type: "Announcement Bar",
        });
      }
    });
  });

  document.querySelectorAll(".menu-drawer__menu-item, .hamburger__root-link").forEach((item) => {
    item.addEventListener("click", (e) => {
      const linkText = e.currentTarget.querySelector(".link-title")
        ? item.querySelector(".link-title").innerText.trim()
        : item?.innerText.trim();

      if (typeof gtag !== "undefined") {
        gtag("event", "user_interaction", {
          link_text: linkText,
          link_target: item?.getAttribute("href"),
          event_category: "User Click",
          event_type: "Hamburger Menu Link",
        });
      }
    });
  });

  document.querySelectorAll(".menu-drawer__menu summary").forEach((item) => {
    item.addEventListener("click", (e) => {
      console.log(e.currentTarget.innerText, `Open ${item.innerText.trim()}`);
      if (typeof gtag !== "undefined") {
        gtag("event", "user_interaction", {
          link_text: item.innerText.trim(),
          link_target: `Open ${item.innerText.trim()} Submenu`,
          event_category: "User Click",
          event_type: "Hamburger Submenu Open",
        });
      }
    });
  });

  document.querySelectorAll(".menu-drawer__close-button").forEach((item) => {
    item.addEventListener("click", (e) => {
      if (typeof gtag !== "undefined") {
        gtag("event", "user_interaction", {
          link_text: item.innerText.trim(),
          link_target: `Close ${item.innerText.trim()} Submenu`,
          event_category: "User Click",
          event_type: "Hamburger Submenu Close",
        });
      }
    });
  });

  document.querySelectorAll(".menu-drawer__shop-all").forEach((item) => {
    item.addEventListener("click", (e) => {
      if (typeof gtag !== "undefined") {
        gtag("event", "user_interaction", {
          link_text: item.innerText.trim(),
          link_target: item.getAttribute("href"),
          event_category: "User Click",
          event_type: "Hamburger Menu Link",
        });
      }
    });
  });

  document.querySelectorAll(".menu-drawer__submenu-all").forEach((item) => {
    item.addEventListener("click", (e) => {
      const submenuTitle = e.currentTarget
        .closest(".menu-drawer__inner-submenu")
        .querySelector(".menu-drawer__close-title").textContent;

      if (typeof gtag !== "undefined") {
        gtag("event", "user_interaction", {
          link_text: `${e.currentTarget.textContent} - ${submenuTitle}`,
          link_target: e.currentTarget.getAttribute("href"),
          event_category: "User Click",
          event_type: "Hamburger Menu Link",
        });
      }
    });
  });
});

window.addEventListener("pageshow", (e) => {
  const sectionsToRefresh = ["cart-drawer", "gift-drawer", "cart-icon-bubble"];
  const cartDrawer = document.querySelector("cart-drawer");
  if (e.persisted) {
    console.log(
      "Persisted event triggered, refreshing sections:",
      sectionsToRefresh,
      `?sections=${sectionsToRefresh.join(",")}`,
    );

    fetch(window.location.pathname + `?sections=${sectionsToRefresh.join(",")}`)
      .then((response) => response.json())
      .then((response) => {
        console.log("Response received for sections refresh:", response);
        if (!response) return;
        const transformedResponse = {};

        transformedResponse.sections = response;

        cartDrawer.renderContents(transformedResponse, false);
      });

    console.log("Refresh Finished");
  }
});
